/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentsResponse as ModelsCustomerCustomerOnlinePaymentsResponse } from '../../models/Models/Customer/customer-online-payments-response';

export interface V3CustomersMeOnlinePaymentsGet$Xml$Params {
  dateFrom?: string;
  dateTo?: string;
  reference?: string;
  pageNumber?: number;
  pageSize?: number;
}

export function v3CustomersMeOnlinePaymentsGet$Xml(http: HttpClient, rootUrl: string, params?: V3CustomersMeOnlinePaymentsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeOnlinePaymentsGet$Xml.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
    rb.query('reference', params.reference, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentsResponse>;
    })
  );
}

v3CustomersMeOnlinePaymentsGet$Xml.PATH = '/v3/customers/me/online-payments';
